"use client";

import {
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Code,
  Link,
  Palette,
  Highlighter,
} from "lucide-react";
import { ComponentType, SVGProps } from "react";

type FormatType =
  | "bold"
  | "italic"
  | "underline"
  | "strikethrough"
  | "code"
  | "link"
  | "textColor"
  | "highlight";

interface FormatIconProps {
  type: FormatType;
  size?: number;
  className?: string;
}

const iconMap: Record<FormatType, ComponentType<SVGProps<SVGSVGElement>>> = {
  bold: Bold,
  italic: Italic,
  underline: Underline,
  strikethrough: Strikethrough,
  code: Code,
  link: Link,
  textColor: Palette,
  highlight: Highlighter,
};

export function FormatIcon({ type, size = 16, className = "" }: FormatIconProps) {
  const Icon = iconMap[type];

  return (
    <Icon
      width={size}
      height={size}
      className={`flex-shrink-0 ${className}`}
    />
  );
}

export { type FormatIconProps, type FormatType };
